import { getStatusMeta } from './emailStatus'

/** Status pill with its icon; `changed` gives it a small pop when it moves on. */
export default function EmailStatusBadge({ status, changed }) {
  const meta = getStatusMeta(status)
  const Icon = meta.icon
  return (
    <span
      key={changed ? `${status}-changed` : status}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${meta.badge} ${changed ? 'animate-copied' : ''}`}
    >
      <Icon className={`h-3 w-3 ${meta.spin ? 'motion-safe:animate-spin' : ''}`} />
      {meta.label}
    </span>
  )
}
